import { createSelector } from '@ngxs/store';
import { FBClientIntakeFormsSelectors } from 'libs/db-access/clientIntakeForms/src/state/clientIntakeForms.firebase.selectors';

export class IntakeFormClientPortalSelectors {
	static readonly fbClientIntakeForm = FBClientIntakeFormsSelectors._props.item;

	static readonly $businessId = FBClientIntakeFormsSelectors._props.businessId;
	static readonly $matterId = FBClientIntakeFormsSelectors._props.matterId;
	static readonly $clientIntakeFormId =
		FBClientIntakeFormsSelectors._props.clientIntakeFormId;

	static readonly $currentIntakeForm = createSelector(
		[IntakeFormClientPortalSelectors.fbClientIntakeForm],
		(fbClientIntakeForm) => {
			return fbClientIntakeForm;
		},
	);

	static readonly $currentIntakeFormId = createSelector(
		[IntakeFormClientPortalSelectors.$currentIntakeForm],
		(currentIntakeForm) => {
			return currentIntakeForm?.id ?? null;
		},
	);
}
